// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Lens_Getter = require("../Data.Lens.Getter/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_Lens_Setter = require("../Data.Lens.Setter/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Profunctor_Strong = require("../Data.Profunctor.Strong/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML = require("../Halogen.HTML/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Lunarbox_Capability_Resource_Project = require("../Lunarbox.Capability.Resource.Project/index.js");
var Lunarbox_Component_Editor = require("../Lunarbox.Component.Editor/index.js");
var Lunarbox_Component_Error = require("../Lunarbox.Component.Error/index.js");
var Lunarbox_Component_HOC_Connect = require("../Lunarbox.Component.HOC.Connect/index.js");
var Lunarbox_Component_Loading = require("../Lunarbox.Component.Loading/index.js");
var Network_RemoteData = require("../Network.RemoteData/index.js");
var Record = require("../Record/index.js");
var Init = (function () {
    function Init() {

    };
    Init.value = new Init();
    return Init;
})();
var Save = (function () {
    function Save(value0) {
        this.value0 = value0;
    };
    Save.create = function (value0) {
        return new Save(value0);
    };
    return Save;
})();
var Receive = (function () {
    function Receive(value0) {
        this.value0 = value0;
    };
    Receive.create = function (value0) {
        return new Receive(value0);
    };
    return Receive;
})();
var _projectData = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "projectData";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var _id = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "id";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
var component = function (dictMonadEffect) {
    return function (dictMonadAff) {
        return function (dictMonadAsk) {
            return function (dictMonadReader) {
                return function (dictManageProjects) {
                    return function (dictNavigate) {
                        var handleEditorOutput = function (v) {
                            if (v instanceof Lunarbox_Component_Editor.Save) {
                                return Data_Maybe.Just.create(new Save(v.value0));
                            };
                            if (v instanceof Lunarbox_Component_Editor.StateEmit) {
                                return Data_Maybe.Nothing.value;
                            };
                            throw new Error("Failed pattern match at Lunarbox.Component.Project (line 97, column 24 - line 99, column 34): " + [ v.constructor.name ]);
                        };
                        var render = function (v) {
                            if (v.projectData instanceof Network_RemoteData.NotAsked) {
                                return Lunarbox_Component_Loading.loading;
                            };
                            if (v.projectData instanceof Network_RemoteData.Loading) {
                                return Lunarbox_Component_Loading.loading;
                            };
                            if (v.projectData instanceof Network_RemoteData.Failure) {
                                return Lunarbox_Component_Error.error(v.projectData.value0);
                            };
                            if (v.projectData instanceof Network_RemoteData.Success) {
                                if (v.currentUser instanceof Data_Maybe.Nothing) {
                                    return Lunarbox_Component_Error.error("not logged in");
                                };
                                if (v.currentUser instanceof Data_Maybe.Just) {
                                    return Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                        return "editor";
                                    }))(Data_Ord.ordUnit)(Data_Symbol.SProxy.value)(Data_Unit.unit)(Lunarbox_Component_Editor.component(dictMonadAff)(dictMonadAff.MonadEffect0())(dictMonadReader)(dictNavigate))({
                                        project: v.projectData.value0.project,
                                        nextId: v.projectData.value0.nextId,
                                        geometries: v.projectData.value0.geometries,
                                        runtimeOverwrites: v.projectData.value0.runtimeOverwrites,
                                        currentFunction: v.projectData.value0.currentFunction,
                                        expression: v.projectData.value0.expression,
                                        typeMap: v.projectData.value0.typeMap,
                                        typeErrors: v.projectData.value0.typeErrors,
                                        lintingErrors: v.projectData.value0.lintingErrors,
                                        currentTab: v.projectData.value0.currentTab,
                                        functionData: v.projectData.value0.functionData,
                                        panelIsOpen: v.projectData.value0.panelIsOpen,
                                        valueMap: v.projectData.value0.valueMap,
                                        inputCountMap: v.projectData.value0.inputCountMap,
                                        pendingConnection: v.projectData.value0.pendingConnection,
                                        name: v.projectData.value0.name,
                                        isExample: v.projectData.value0.isExample,
                                        isAdmin: v.currentUser.value0.isAdmin,
                                        nodeSearchTerm: v.projectData.value0.nodeSearchTerm,
                                        isVisible: v.projectData.value0.isVisible,
                                        currentlyEditedNode: v.projectData.value0.currentlyEditedNode,
                                        autosaveInterval: v.projectData.value0.autosaveInterval,
                                        emitInterval: v.projectData.value0.emitInterval
                                    })(handleEditorOutput);
                                };
                                throw new Error("Failed pattern match at Lunarbox.Component.Project (line 105, column 22 - line 107, column 125): " + [ v.currentUser.constructor.name ]);
                            };
                            throw new Error("Failed pattern match at Lunarbox.Component.Project (line 101, column 41 - line 107, column 125): " + [ v.projectData.constructor.name ]);
                        };
                        var handleAction = function (v) {
                            if (v instanceof Init) {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Getter.view(_id(Data_Lens_Internal_Forget.strongForget))))(function (id) {
                                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Capability_Resource_Project.getProject(Lunarbox_Capability_Resource_Project.manageUserHalogenM(dictManageProjects))(id))(function (response) {
                                        return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(_projectData(Data_Profunctor_Strong.strongFn))(Network_RemoteData.fromEither(response)));
                                    });
                                });
                            };
                            if (v instanceof Receive) {
                                return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Record.merge()()(v.value0));
                            };
                            if (v instanceof Save) {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.gets(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Getter.view(_id(Data_Lens_Internal_Forget.strongForget))))(function (id) {
                                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Lunarbox_Capability_Resource_Project.saveProject(Lunarbox_Capability_Resource_Project.manageUserHalogenM(dictManageProjects))(id)(v.value0))(function (response) {
                                        if (response instanceof Data_Either.Left) {
                                            return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(Data_Lens_Setter.set(_projectData(Data_Profunctor_Strong.strongFn))(new Network_RemoteData.Failure(response.value0)));
                                        };
                                        return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                    });
                                });
                            };
                            throw new Error("Failed pattern match at Lunarbox.Component.Project (line 83, column 18 - line 94, column 23): " + [ v.constructor.name ]);
                        };
                        return Lunarbox_Component_HOC_Connect.component(dictMonadAff)(dictMonadAsk)()(Halogen_Component.mkComponent({
                            initialState: Record.merge()()({
                                projectData: Network_RemoteData.NotAsked.value
                            }),
                            render: render,
                            "eval": Halogen_Component.mkEval({
                                handleAction: handleAction,
                                handleQuery: Halogen_Component.defaultEval.handleQuery,
                                receive: function ($30) {
                                    return Data_Maybe.Just.create(Receive.create($30));
                                },
                                initialize: new Data_Maybe.Just(Init.value),
                                finalize: Halogen_Component.defaultEval.finalize
                            })
                        }));
                    };
                };
            };
        };
    };
};
module.exports = {
    component: component
};
